import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/report-management/financial-report`;

export const financialReportRoutesObj = {
  list: baseRoute,
  // TODO: ADD VIEW INVOICE AND DEBT PAYMENT PAGES LATER
} as const;

export type IFinancialReportRouteParams = IExtractRouteParamMap<
  typeof financialReportRoutesObj
>;

export const financialReportPath = createPaths<
  typeof financialReportRoutesObj,
  IFinancialReportRouteParams
>(financialReportRoutesObj);
